module.exports = __webpack_public_path__ + "img/about_p1-image.8065d5ac.jpg";